module.exports = __webpack_public_path__ + "static/media/laloop.ae1f0175.png";